const enum QUESTION_IDS {
  ROOM_FOCUS = '-1',
  HOME_TYPE = '1',
  HOME_OWNERSHIP = '2',
  HOME_LOCATION = '3',
  ROOM_STATUS = '4',
  TIMEFRAME = '5',
  BUDGET = '8',
  NAME = '21',
  DESIGN_EXPERIENCE = '22',
  ROOM_SELECTION = '23',
  STYLE_INSPIRATION = '24',
  STYLE = '25',
  EMAIL = '27',
  INTERSTITIAL = '28',
  STYLE_REVEAL = '29',
  STYLE_KEYWORDS = '30',
  LIFE_EVENTS = '31',
  DESIGN_STRUGGLES = '32',
  HOME_ZIP_CODE = '33',
  DESIGNER_FIT = '34',
  RANGED_BUDGET = '35',
}

export default QUESTION_IDS;
